"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Batch extends Api_1.default {
    constructor(props) {
        super(props);
    }
    /**
     * Returns the batch with the given id
     * @param batch_id
     * @returns
     */
    get(batch_id) {
        const requestObj = {
            method: 'get',
            url: `/batch/${batch_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the batches created by the user. The batches are sorted descending by date of creation.
     * @returns
     */
    getAll() {
        const requestObj = {
            method: 'get',
            url: `/batch/`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the currently running batches on the given reference.
     * @param ref_type
     * @param ref_id
     * @param plugin
     * @returns
     */
    getRunningBatches(ref_type, ref_id, plugin) {
        const requestObj = {
            method: 'get',
            url: `/batch/${ref_type}/${ref_id}/${plugin}/running/`,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Batch;
